import type { FC } from "react";

import { Inline, Stack } from "@/ui/components/layout";
import { Button } from "@/ui/components/primitives";
import { TextSubtitle } from "@/ui/components/typography/TextSubtitle";
import type { TOverviewEditCardProps } from "./OverviewEditCard.config";
import { useOverviewEditCard } from "./useOverviewEditCard";

export const OverviewEditCard: FC<TOverviewEditCardProps> = ({
  title,
  onEdit,
  children,
}) => {
  const { editCopy } = useOverviewEditCard();

  return (
    <Inline data-component="OverviewEditCard" className="flex-1">
      <Stack gap="2">
        <TextSubtitle size={3}>
          { title }
        </TextSubtitle>
        <div>
          { children }
        </div>
      </Stack>
      <div>
        <Button onClick={onEdit} variant="tertiary" icon="pencil">
          { editCopy }
        </Button>
      </div>
    </Inline>
  );
};
